/**
 * ProcessForm — Process-level fields
 *
 * Renders process name, ID (auto-generated from name), and enabled toggle.
 * Used in wizard step 1 and when clicking a process header in the editor sidebar.
 */

import React from 'react';
import HelpPanel from './HelpPanel';
import { SECTION_HELP } from './utils/labelMapping';

function slugify(name) {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

export default function ProcessForm({
  process,
  processIndex,
  onUpdate,
  showHelp = false,
  showEnabled = true,
  readOnly = false,
}) {
  function handleUpdate(field, value) {
    onUpdate(processIndex, field, value);

    // Auto-generate process_id from name if ID is empty or was auto-generated
    if (field === 'process_name' && !process.process_id) {
      onUpdate(processIndex, 'process_id', slugify(value));
    }
  }

  if (readOnly) {
    return (
      <div className="config-section-card">
        <div className="config-section-header">
          <span className="config-section-label">Process</span>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label className="form-label">Process Name</label>
            <div className="config-read-value">{process.process_name || '—'}</div>
          </div>
          <div className="form-group">
            <label className="form-label">Process ID</label>
            <div className="config-read-value mono">{process.process_id || '—'}</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="config-section-card">
      <div className="config-section-header">
        <span className="config-section-label">Process</span>
        <div className="flex items-center gap-8">
          {showHelp && (
            <HelpPanel title={SECTION_HELP.process.title} content={SECTION_HELP.process.content} />
          )}
          {showEnabled && (
            <label className="toggle" style={{ marginBottom: 0 }}>
              <input
                type="checkbox"
                checked={process.enabled}
                onChange={e => handleUpdate('enabled', e.target.checked)}
              />
              <div className="toggle-track" /><div className="toggle-thumb" />
              <span className="toggle-label">{process.enabled ? 'Enabled' : 'Disabled'}</span>
            </label>
          )}
        </div>
      </div>
      <div className="form-row">
        <div className="form-group">
          <label className="form-label">Process Name</label>
          <input
            className="form-input"
            value={process.process_name}
            onChange={e => handleUpdate('process_name', e.target.value)}
            placeholder="Invoice Approval Workflow"
          />
        </div>
        <div className="form-group">
          <label className="form-label">Process ID</label>
          <input
            className="form-input mono"
            value={process.process_id}
            onChange={e => handleUpdate('process_id', e.target.value)}
            placeholder="invoice-approval"
          />
          <p className="form-hint">Lowercase letters, numbers, and hyphens only.</p>
        </div>
      </div>
    </div>
  );
}
